import { useContext, useEffect, useId, useRef } from 'react';
import { ThemeControllerContext, type ThemeOverride } from './Context';

export const useThemeOverride = (override: Omit<ThemeOverride, 'id'>) => {
    const id = useId();
    const dispatch = useContext(ThemeControllerContext);
    const registeredRef = useRef(false);

    if (!dispatch) {
        throw new Error('Theme controller context is missing');
    }

    // register or update whenever the override changes
    useEffect(() => {
        // sent the override
        dispatch({
            type: registeredRef.current ? 'update' : 'register',
            override: { id, ...override },
        });

        // update reference to update next time
        registeredRef.current = true;
    }, [dispatch, id, override, registeredRef]);

    // unregister when unmounting
    useEffect(() => () => dispatch({ type: 'unregister', id }), [dispatch, id]);
};
